import { apiUrl } from '../config';

function todayKey(sign, day = 'today', lang = 'en') {
  const d = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
  return `horo:${sign}:${day}:${lang}:${d}`;
}

export async function getTodayHoroscope(sign, lang = 'en') {
  const s = (sign || '').toLowerCase();
  if (!s) return null;

  const key = todayKey(s, 'today', lang);

  try {
    const cached = localStorage.getItem(key);
    if (cached) {
      const obj = JSON.parse(cached);
      if (obj?.description) return obj;
    }
  } catch {}

  const r = await fetch(apiUrl(`/api/horoscope?sign=${encodeURIComponent(s)}&day=today`));
  if (!r.ok) throw new Error(`HTTP_${r.status}`);
  const j = await r.json();

// If English, use directly
  if (lang === 'en') {
    try { localStorage.setItem(key, JSON.stringify(j)); } catch {}
    return j;
  }

  // Translate description only
  const tr = await fetch(apiUrl("/api/translate-quote"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ text: j.description, target: lang })
  });
  const trJson = await tr.json();
  const translated = trJson.translated || j.description;

  const translatedHoro = { ...j, description: translated };
  try { localStorage.setItem(key, JSON.stringify(translatedHoro)); } catch {}
  return translatedHoro;
}